import { FaShare } from "react-icons/fa";
import useSbConfig from "../Shared/useSbConfig";
import ActionButton from "../Shared/ActionButton";

export default ({
  product
}) => {
  const {
    id
  } = product
  
  const sbConfig = useSbConfig()

  const viewProduct = () => {
    // 1.0 ${sbConfig.merchantUrl}/App/Merchant/#/Products/${product.id}
    // 2.0 ${sbConfig.merchantUrl}/App/merchant/#/product-catalog/${product.id}
    window.open(`${sbConfig.merchantUrl}/App/merchant/#/product-catalog/${id}`)
  }

  return (
    <ActionButton onClick={viewProduct}>
      <FaShare style={{ paddingRight: '10px' }} />
      View
    </ActionButton>
  )
}